import "./dashboard.css";
function Dashboard() {
  return <div className="dash">Welcome to Study notion</div>;
}

export default Dashboard;
